var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalogMenu4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3993 2.68407L17.9473 4.00579V1.58029C17.9473 1.23537 18.2166 0.959437 18.5532 0.959437H20.2364C20.573 0.959437 20.8423 1.23537 20.8423 1.58029V6.46693L23.1319 8.40973C25.623 10.4792 22.526 10.6172 16.736 10.6172H11.8885H3.27071C-1.6441 10.6172 -0.297573 9.23754 2.59745 6.75412L5.02119 4.68461L9.33007 1.02846C11.7538 -1.04106 13.5043 0.269638 16.3993 2.68407ZM20.5742 22.0685V12.2728H16.198V19.1712C16.198 19.723 15.794 20.1369 15.2554 20.1369H8.52281C7.9842 20.1369 7.58025 19.723 7.58025 19.1712V12.2728H3.13672V22.0685C3.13672 23.1032 4.01196 24 5.02185 24H18.6891C19.699 24 20.5742 23.1032 20.5742 22.0685Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28F14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogMenu4);
export default __webpack_public_path__ + "static/media/catalog-menu-4.04af29db67193bae0c38e071ae19e56b.svg";
export { ForwardRef as ReactComponent };